coireqEntityChanged = function () {
    let url = window.location.href.toString()
    let val = document.getElementById('entity-type').value
    if (url.indexOf('?') > -1) {
        url = url.split('?', 1)[0];
    }
    url += "?entityType=" + val
    window.location.href = url
}
